export const formatCardNumber = (cardNumber: string) =>
  cardNumber.replace(/(\d{4})(\d{4})(\d{4})(\d{5})/, '$1 $2 $3 $4');
